export default __webpack_public_path__ + "images/blue-arrow.png?e5a5e51325ff116ffb9695667249dc8d";